@import (reference) '../../../../constants/spacing.module.less';

.shipment-details-layout-column {
  display: flex;
  flex-flow: column nowrap;
  row-gap: @space-16;
  overflow-wrap: anywhere;
}

.address-column {
  .shipment-details-layout-column();
  grid-area: address-column;
}

.cost-summary-column {
  .shipment-details-layout-column();
  grid-area: cost-summary-column;
}

.dates-column {
  .shipment-details-layout-column();
  grid-area: dates-column;
}

.assignment-column {
  .shipment-details-layout-column();
  grid-area: assignment-column;
}

.shipment-details-column-divider {
  border-right: 1px solid var(--default--border-color--13);
  grid-area: divider-column;
}
